import DropGate from "@pathwright/ui/src/components/drop/DropGate"
import { useState } from "react"
import styled from "styled-components"
import Activity from "../../../activity/Activity"
import { LEARNING_ACTION_FILTER_NONE } from "../../../activity/constants"
import useCohortPermissions from "../../../cohort/useCohortPermissions"
import { FEATURE_PERMISSION_DISABLED } from "../../../feature/constants"
import { getPlatformUrl } from "../../../utils/urls"
import { useCommunityContext } from "../../Community"
import useCommunityAreaFeaturePermission from "../useCommunityAreaFeaturePermission"
import useCommunityAreas from "../useCommunityAreas"
import CommunityActivityFilter from "./CommunityActivityFilter"

// hacky alignment
const StyledContainer = styled.div`
  .ActivityTimeline__feed {
    padding-left: 0;
    padding-right: 0;
  }
`

const CommunityActivityDrop = () => {
  return (
    <DropGate
      title="Cohort Timeline unlocks soon"
      description={`As part of Season 1, we'll add Timeline and other Community features.`}
      link={getPlatformUrl("/library/season-i-cohort/211635/path/")}
      linkLabel="Join the Season Path"
    />
  )
}

const CommunityActivity = ({ inverted }) => {
  const { resourceId, cohortId } = useCommunityContext()
  const [filter, setFilter] = useState(LEARNING_ACTION_FILTER_NONE)
  const { featurePermission } = useCommunityAreaFeaturePermission()
  const { selectedArea } = useCommunityAreas()
  const cohortPerms = useCohortPermissions({ cohortId })

  if (featurePermission === FEATURE_PERMISSION_DISABLED) {
    return <CommunityActivityDrop />
  }

  return (
    <StyledContainer>
      <CommunityActivityFilter
        filter={filter}
        onFilter={setFilter}
        inverted={inverted}
      />
      <Activity
        resourceId={resourceId}
        groupId={cohortId}
        actionType={filter}
        inverted={inverted}
        canViewAvatarCard={true}
        canViewAvatarProfile={cohortPerms.hasEditorLevelAccess}
      >
        {selectedArea.renderBlankSlate}
      </Activity>
    </StyledContainer>
  )
}

CommunityActivity.displayName = "CommunityActivity"

export default CommunityActivity
